var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: _vm.editorText + "参赛获奖得分规则",
        visible: _vm.dialogVisible,
        "custom-class": "zyyj-dialog",
        direction: "rtl",
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.handleOpen
      }
    },
    [
      _c(
        "div",
        { staticStyle: { height: "calc(100% - 105px)", padding: "0 20px" } },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "scroll",
              attrs: { "label-width": "120px", model: _vm.form }
            },
            _vm._l(_vm.form.rules, function(item, index) {
              return _c(
                "el-row",
                { key: item.value, staticClass: "row" },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "level" }, [
                      _vm._v("获奖等级：" + _vm._s(item.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "记录次数",
                            prop: "rules." + index + ".times",
                            rules: {
                              required: true,
                              message: "记录次数不能为空",
                              trigger: ["blur", "change"]
                            }
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请填写记录次数最大值" },
                              on: {
                                change: function(val) {
                                  return _vm.changeTime(val, index)
                                }
                              },
                              model: {
                                value: item.times,
                                callback: function($$v) {
                                  _vm.$set(item, "times", $$v)
                                },
                                expression: "item.times"
                              }
                            },
                            _vm._l(_vm.times, function(item) {
                              return _c("el-option", {
                                key: item,
                                attrs: { label: item, value: item }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  item.times
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "得分描述",
                                prop: "rules." + index + ".score",
                                rules: [
                                  {
                                    required: true,
                                    message: "得分比例不能为空",
                                    trigger: "blur"
                                  }
                                ]
                              }
                            },
                            _vm._l(item.score, function(time, index) {
                              return _c(
                                "div",
                                {
                                  key: time.count,
                                  staticStyle: { "margin-left": "15px" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "margin-right": "75px"
                                      }
                                    },
                                    [_vm._v(_vm._s(index + 1) + "次")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "#757575"
                                      }
                                    },
                                    [_vm._v("得分比例")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 0,
                                      max: 100,
                                      controls: false,
                                      disabled: index === item.score.length - 1
                                    },
                                    model: {
                                      value: time.score,
                                      callback: function($$v) {
                                        _vm.$set(
                                          time,
                                          "score",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "time.score"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("%")])
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "drawer-footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                disabled: _vm.submitting
              },
              on: {
                click: function($event) {
                  return _vm.submitForm("form")
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-19b4d9fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-19b4d9fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AddReward.vue
// module id = null
// module chunks = 